<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/filter.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Workflow Access</span>
    <app-upgrade-badge scope="watermark:create" location="gallery-workflow-setting-item"></app-upgrade-badge>
  </app-access-item-header>
  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input
        type="checkbox"
        id="gallery-workflow-setting"
        [(ngModel)]="galleryWorkflow"
        (ngModelChange)="updategalleryWorkflow()"
        [disabled]="!('gallery:client-advanced-mode' | billingScope)"
      />
      <label for="gallery-workflow-setting" data-test-id="gallery-workflow-setting"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
